import { IConfig } from "./Render";
export const Svg = ({id, height, width, children, className, viewBox, style}:IConfig)=>
{
    return (
        <svg  id={id} viewBox={viewBox} height={height} width={width} className={className} style={style}>{children}</svg>
    );
}